/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect, IndexRou } from "react-router-dom";
import App from './App';


import "assets/scss/material-dashboard-pro-react.scss?v=1.7.0";

const hist = createBrowserHistory();

ReactDOM.render(<App />, document.getElementById('root'));

// ReactDOM.render(
//   <Router history={hist}>
//     {/* <Router path="/" > */}
//       <Route path={"/home"} component={Home} />
//       <Route path={"/novedades"} component={Novedades} />
//     {/* </Router> */}
//     {/* <Switch> */}
//     {/* <Route path="/rtl" component={RtlLayout} /> */}
//     {/* <Route path="/auth" component={AuthLayout} /> */}

//     {/* <Redirect from="/" to="/admin/dashboard" /> */}
//     {/* </Switch> */}
//   </Router>,
//   document.getElementById("root")
// );
